var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclusion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.541 6.84532C12.0094 6.57072 12.5897 6.57072 13.0581 6.84532L21.6917 11.9064C22.6802 12.4859 22.6802 13.9149 21.6917 14.4944L13.0581 19.5555C12.5897 19.8301 12.0094 19.8301 11.541 19.5555L2.90745 14.4944C1.91888 13.9149 1.91888 12.4859 2.90744 11.9064L11.541 6.84532Z",
    fill: "#F5C8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.541 3.64317C12.0094 3.36857 12.5897 3.36857 13.0581 3.64317L21.6917 8.7042C22.6802 9.2837 22.6802 10.7128 21.6917 11.2923L13.0581 16.3533C12.5897 16.6279 12.0094 16.6279 11.541 16.3533L2.90745 11.2923C1.91888 10.7128 1.91888 9.2837 2.90744 8.7042L11.541 3.64317Z",
    fill: "#DEA5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.541 0.444685C12.0094 0.170081 12.5897 0.17008 13.0581 0.444684L21.6917 5.50572C22.6802 6.08522 22.6802 7.51431 21.6917 8.09381L13.0581 13.1548C12.5897 13.4294 12.0094 13.4294 11.541 13.1548L2.90745 8.09381C1.91888 7.51431 1.91888 6.08522 2.90744 5.50572L11.541 0.444685Z",
    fill: "#C67C78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusion);
export default __webpack_public_path__ + "static/media/exclusion.7ac7fa39e32269c253ef554ea22d904f.svg";
export { ForwardRef as ReactComponent };